import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_UNSPLASH_SEARCH = `${ENDPOINT_BASE}/unsplash/search`
export const ENDPOINT_UNSPLASH_DOWNLOAD_TRACKING = `${ENDPOINT_BASE}/unsplash/download-tracking`
